<script setup lang="ts">
import ArrowUpRightIcon from '@/assets/icons/ArrowUpRightIcon.vue';
import CloseIcon from '@/assets/icons/CloseIcon.vue';
import ExternalMaterialLogo from '@/core/supportMeasures/ExternalMaterialLogo.vue';

export interface IExternalMaterialRowMaterial {
  name: string;
  logoUrl: string | null;
  sourceUrl?: string | null;
  isOfficial?: boolean;
}

withDefaults(
  defineProps<{
    material: IExternalMaterialRowMaterial;
    removable?: boolean;
    disabled?: boolean;
    noteTone?: boolean;
    density?: 'default' | 'protocol';
  }>(),
  { removable: false, disabled: false, noteTone: false, density: 'default' },
);

const emit = defineEmits<{ remove: [] }>();
</script>

<template>
  <div class="flex items-center gap-md px-md py-sm">
    <ExternalMaterialLogo
      :logo-url="material.logoUrl"
      :custom="material.isOfficial === false"
      :large-icon="density === 'protocol'"
      :class="density === 'protocol' ? 'size-[36px]' : 'size-avatar'"
    />

    <span class="min-w-0 flex-1 truncate" :class="density === 'protocol' ? 'text-body' : 'text-base text-primary'">
      {{ material.name }}
    </span>

    <button
      v-if="removable"
      type="button"
      :class="[
        'flex size-8 shrink-0 items-center justify-center rounded-button state-effects',
        noteTone ? 'text-note-accent' : 'text-secondary',
      ]"
      :disabled="disabled"
      :aria-label="$t('general.remove')"
      @click="emit('remove')"
    >
      <CloseIcon class="size-icon-sm" />
    </button>
    <a
      v-else-if="material.sourceUrl"
      :href="material.sourceUrl"
      target="_blank"
      rel="noopener noreferrer"
      :class="[
        'flex size-8 shrink-0 items-center justify-center rounded-full state-effects',
        noteTone ? 'text-note-accent' : 'text-secondary',
      ]"
      :aria-label="$t('supportMeasureEntry.materials.visitWebsite')"
    >
      <ArrowUpRightIcon class="size-icon-sm" />
    </a>
  </div>
</template>
